module.exports = __webpack_public_path__ + "static/media/Rectangle 68.1cdec94a.svg";